// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-resizable {
    position: relative;
  }
  .react-resizable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: se-resize;
  }

.app-components-Modal-___MUIModal-module__exponentTitle {
  position: absolute;
  top: 0px;
  left: 5px;
  font-size: 13px;
}

.app-components-Modal-___MUIModal-module__childrenContainer {
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px;
}

.app-components-Modal-___MUIModal-module__contentContainer {
  padding: 15px;
  height: 100%;
  max-width: 100%;
}

.app-components-Modal-___MUIModal-module__buttonsContainer {
  right: -10px;
  position: sticky;
  bottom: 0px;
  float: right;
  padding: 10px;
  background-color: #ffffff;
  height: 48px;
  border-top-left-radius: 5px;
}

.app-components-Modal-___MUIModal-module__error {
  color: tomato;
  padding: 10px;
}

.app-components-Modal-___MUIModal-module__dialogRoot {
  z-index: 300 !important;
  max-height: calc(100% - 20px) !important;
  margin-top: 15px !important;
}

.app-components-Modal-___MUIModal-module__dialogRoot:focus-within {
  z-index: 301 !important;
}

.app-components-Modal-___MUIModal-module__dialogScrollPaper {
  height: initial !important;
}

.app-components-Modal-___MUIModal-module__closeModalIcon {
  font-size: 20px;
  opacity: 0.6;
  cursor: pointer;
  transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./app/components/Modal/MUIModal.module.scss"],"names":[],"mappings":"AACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,mDAAiY;IACjY,iCAAiC;IACjC,oBAAoB;IACpB,4BAA4B;IAC5B,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;EACnB;;AAGF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[":global {\n  .react-resizable {\n    position: relative;\n  }\n  .react-resizable-handle {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    bottom: 0;\n    right: 0;\n    background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+');\n    background-position: bottom right;\n    padding: 0 3px 3px 0;\n    background-repeat: no-repeat;\n    background-origin: content-box;\n    box-sizing: border-box;\n    cursor: se-resize;\n  }\n}\n\n.exponentTitle {\n  position: absolute;\n  top: 0px;\n  left: 5px;\n  font-size: 13px;\n}\n\n.childrenContainer {\n  height: calc(100% - 40px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 2px;\n}\n\n.contentContainer {\n  padding: 15px;\n  height: 100%;\n  max-width: 100%;\n}\n\n.buttonsContainer {\n  right: -10px;\n  position: sticky;\n  bottom: 0px;\n  float: right;\n  padding: 10px;\n  background-color: #ffffff;\n  height: 48px;\n  border-top-left-radius: 5px;\n}\n\n.error {\n  color: tomato;\n  padding: 10px;\n}\n\n.dialogRoot {\n  z-index: 300 !important;\n  max-height: calc(100% - 20px) !important;\n  margin-top: 15px !important;\n}\n\n.dialogRoot:focus-within {\n  z-index: 301 !important;\n}\n\n.dialogScrollPaper {\n  height: initial !important;\n}\n\n.closeModalIcon {\n  font-size: 20px;\n  opacity: 0.6;\n  cursor: pointer;\n  transform: rotate(45deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exponentTitle": `app-components-Modal-___MUIModal-module__exponentTitle`,
	"childrenContainer": `app-components-Modal-___MUIModal-module__childrenContainer`,
	"contentContainer": `app-components-Modal-___MUIModal-module__contentContainer`,
	"buttonsContainer": `app-components-Modal-___MUIModal-module__buttonsContainer`,
	"error": `app-components-Modal-___MUIModal-module__error`,
	"dialogRoot": `app-components-Modal-___MUIModal-module__dialogRoot`,
	"dialogScrollPaper": `app-components-Modal-___MUIModal-module__dialogScrollPaper`,
	"closeModalIcon": `app-components-Modal-___MUIModal-module__closeModalIcon`
};
export default ___CSS_LOADER_EXPORT___;
